<template>
  <div class="mt-5">
    <div
      class="mb-3"
      v-for="(variant, variantKey) in variants"
      :key="`variant-key-${variantKey}`"
    >
      <div class="group">
        <h5>{{ "answer_ponint" | setText("Пункт") }} {{ variantKey + 1 }}</h5>

        <RichEditor
          v-model="variant.description"
        />
      </div>

      <div v-show="variant.answers" class="mt-3">
        <div class="group">
          <h6>
            {{ "add_variant_question" | setText("Добавить вариант ответа") }}
          </h6>

          <fg-input v-model="answerTitle" type="text"></fg-input>
          <checkbox v-model="answerIsCorrect" color="#ffc107">{{
            "right" | setText("Правильный")
          }}</checkbox>
        </div>

        <button
          @click="addAnswer(variantKey)"
          class="btn btn-sm mt-2 mb-4 btn-info"
        >
          {{ "Добавить ответ" }}
        </button>

        <div v-show="variant.answers.length">
          <draggable
            :tag="'ul'"
            v-model="variant.answers"
            handle=".handle-new"
            class="row"
          >
            <li
              v-for="(answer, answerKey) in variant.answers"
              :key="`answer-${answerKey}`"
              class="col-12 col-md-6 handle-new"
            >
              <div class="group">
                <fg-input type="text" v-model="answer.title"></fg-input>

                <div class="actions-wrapper">
                  <checkbox v-model="answer.is_true" color="#ffc107">{{
                    "right" | setText("Правильный")
                  }}</checkbox>
                  <button
                    @click="removeAnswer(variantKey, answerKey)"
                    class="btn btn-sm btn-danger"
                  >
                    <span class="ti-trash"></span>
                  </button>
                </div>
              </div>
            </li>
          </draggable>
        </div>
      </div>
    </div>

    <button @click="addVariant()" class="btn btn-sm my-4 add-point-button">
      {{ "Добавить пункт" }}
    </button>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import RichEditor from "@/components/Editor/RichTextEditor.vue";

export default {
  name: "Dropdown",
  components: { draggable, RichEditor },

  props: {
    item: Object,
    itemKey: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      variants: [],
      answerTitle: "",
      answerIsCorrect: false,
    };
  },
  mounted() {
    this.variants = this.item.metadata.variants;
  },
  methods: {
    addVariant() {
      this.$emit("dropdown-variant-added", {
        itemKey: this.itemKey,
        description: "",
        answers: [],
      });
    },
    addAnswer(variantKey) {
      this.$emit("dropdown-variant-answer-added", {
        itemKey: this.itemKey,
        variantKey: variantKey,
        answerData: {
          title: this.answerTitle,
          is_true: this.answerIsCorrect,
        },
      });

      this.answerTitle = "";
      this.answerIsCorrect = false;
    },

    removeAnswer(variantKey, answerKey) {
      this.$emit("dropdown-variant-answer-removed", {
        itemKey: this.itemKey,
        variantKey: variantKey,
        answerKey: answerKey,
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.add-point-button {
  background-color: #800080;
}
.actions-wrapper {
  display: flex;

  .m-chckbox--container {
    width: auto !important;
    margin-right: 10px !important;
  }
}
</style>
